import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deleteOffer: null,
  loading: false,
  error: null,
};

const deleteOfferSlice = createSlice({
  name: "deleteOffer",
  initialState,

  reducers: {
    fetchDeleteOfferStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchDeleteOfferSuccess: (state, action) => {
      state.loading = false;
      state.deleteOffer = action.payload;
      state.error = null;
    },

    fetchDeleteOfferFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchDeleteOfferStart,
  fetchDeleteOfferSuccess,
  fetchDeleteOfferFailure,
} = deleteOfferSlice.actions;

export default deleteOfferSlice.reducer;